import React, {useMemo} from 'react'
import {Article} from "../../../../../types/Article";
import styles from './ArticleCard.module.scss'
import parseStringToHTML from "../../../../../helpers/parseStringToHTML";
import Image from "../../../../../components/Image";
import Text from "../../../../../components/Text";
import Card from "../../../../../components/Card";
import {useTranslation} from "react-i18next";
import cx from "classnames";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import IconButton from "../../../../../components/IconButton";

type ArticleCardProps = Article & {handleDelete: () => void}

const ArticleCard: React.FC<ArticleCardProps> = (
    {
        cName,
        cArtNr,
        imgUrl,
        price,
        handleDelete
    }
) => {
    const { t } = useTranslation(['individualization'])

    const getPriceString = useMemo(() => {
        return parseStringToHTML(price[1]) + ' (' + parseStringToHTML(price[0]) + t('article_card.tax') +')'
    }, [t, price])

    return (
        <Card classes={cx(styles['zr-card-wrapper'])}  title={parseStringToHTML(cName)}>
            <IconButton
                icon={faTrashAlt}
                classes={cx(styles['zr-card-icon'])}
                color={'#2f2f2f'} onClick={() => handleDelete()}
            />
            <div className={cx(styles['zr-card-inner-wrapper'])}>
                <Image src={imgUrl} alt={'placeholder'}/>
                <div className={cx(styles['zr-card-lines'])}>
                    <div className={cx(styles['zr-card-line'])}>
                        <Text classes={'mt-2 font-weight-bold'}>
                            {t('article_card.article_number')}
                        </Text>
                        <Text classes={'mt-2'}>{cArtNr}</Text>
                    </div>
                    <div className={cx(styles['zr-card-line'], 'mt-2')}>
                        <Text classes={'font-weight-bold'}>
                            {t('article_card.price')}
                        </Text>
                        <Text>{getPriceString}</Text>
                    </div>
                </div>
            </div>
        </Card>
    )
}

export default ArticleCard
